
import { AppSettings } from './types';

export const DEFAULT_CONFIG: AppSettings = {
  logoUrl: 'https://soescritorio.com.br/wp-content/uploads/2025/12/logo_so_escritorio_wiki_4.png', // A placeholder image that aligns with the primary color
  loginBackgroundImageUrl: 'https://soescritorio.com.br/wp-content/uploads/2025/12/img_login_wiki.jpg', // A nice default office image
  appName: 'SÓES Wiki',
  primaryColor: '#2563eb', // A default blue color
  lastUpdatedAt: Date.now(), // Added: Default timestamp for initial config
};
